import { Component, Inject, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { AuthService } from "../../core/services/auth/auth.service";
import { UserSite } from "../../core/data/models/get-user-with-sites-links-info";

export interface PeriodicElement {
  siteAddress: string;
  siteName: string;
  companyName: string;
}

@Component({
  selector: "app-user-site-links-dialog",
  templateUrl: "./user-site-links-dialog.component.html",
  styleUrls: ["./user-site-links-dialog.component.scss"],
})
export class UserSiteLinksDialogComponent implements OnInit {
  displayedColumns: string[] = ["siteName", "siteAddress", "companyName"];

  @Input() public siteInfo: UserSite[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public sites: UserSite[],

    public confirmDialog: MatDialog,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<UserSiteLinksDialogComponent>,
    private router: Router,
    public auth: AuthService
  ) {}

  ngOnInit() {}

  // 施設選択
  onClickSelectSite() {
    if (!navigator.onLine) {
      alert("ネットワーク接続を確認してください");
      return;
    }
  }
}
